import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

// 管理员
export default {
  getAdminList(params) { // 管理员用户列表
    const url =  baseURL + '/tbAdminuser/list';
    return axios.post(url, qs.stringify(params));
  },
  setAdmin(params) { // 新增管理员
    const url =  baseURL + '/tbAdminuser/addAdminUser';
    return axios.post(url, qs.stringify(params));
  },
  delAdmin(params) { // 删除管理员
    const url =  baseURL + '/tbAdminuser/delete';
    return axios.post(url, qs.stringify(params));
  },
  editAdmin(params) { // 重置管理员用户密码
   // const url =  baseURL + '/tbAdminuser/adminUserPasswordReset';
    const url =  baseURL + '/tbAdminuser/adminUserModify';
    return axios.post(url, qs.stringify(params));
  },
  loginAdmin(params){// 管理员登录
    const url =  baseURL + '/tbAdminuser/adminUserlogin';
    return axios.post(url, qs.stringify(params));
  },
  setUserModule(params){// 用户管理 授权审批
    const url =  baseURL + '/tbUser/setUserModule';
    return axios.post(url, qs.stringify(params));
  },
  delUser(params){// 删除用户
    const url =  baseURL + '/tbUser/delete';
    return axios.post(url, qs.stringify(params));
  },
  modifyUser(params){// 修改用户
    const url =  baseURL + '/tbUser/modify';
    return axios.post(url, qs.stringify(params));
  },
  addUserSingle(params){// 新增用户
    const url =  baseURL + '/tbUser/addUserSingle';
    return axios.post(url, qs.stringify(params));
  },

  // 校验手机号是否被注册
  checkPhoneUnique(param) {
      const url = baseURL + '/tbUser/userPhoneCheck?phone='+ param.phone;
      return axios.post(url)
  },
  
  UserList(params){// 用户类型
    const url =  baseURL + '/tbType/list';
    return axios.post(url, qs.stringify(params));
  },
  AccList(params){// 账户类型
    const url =  baseURL + '/tbCode/getAcountList';
    return axios.post(url, qs.stringify(params));
  },
  getList(params){// 用户产品列表
    const url =  baseURL + '/tbAuthorizedproduct/getList';
    return axios.post(url, qs.stringify(params));
  },
  getUserModulePointPie(params){// 2、个人用户模块使用情况分析 
    const url =  baseURL + '/tbAuthorizedproduct/getUserModulePointPie';
    return axios.post(url, qs.stringify(params));
  },
  loginRecord(params){// 3、登录时间日历标记，统计登录天数总数，查询时间月、季、半年、年 
    const url =  baseURL + '/tbUser/loginRecord';
    return axios.post(url, qs.stringify(params));
  },
  pointByPerson(params){// 4、积分曲线，查询时间月、季、半年、年 
    const url =  baseURL + '/tbUser/pointByPerson';
    return axios.post(url, qs.stringify(params));
  },
  importUserExcelfile(param,data){
    const url = `${baseURL}/tbUser/importUserExcel?${param}`
    return axios.post(url, data)
  },
  tbCompanyList(params){// 公司列表
    const url =  baseURL + '/tbCompany/companyList';
    return axios.post(url, qs.stringify(params));
  },
  getCompanyManage(params){// 获取企业管理员信息
    const url =  baseURL + '/tbCompany/getCompanyManage';
    return axios.post(url, qs.stringify(params));
  },
  exportPointExcel(params){// 导出企业信息
    const url =  baseURL + '/tbAuthorizedproduct/exportPointExcel';
    return url;
  },
  setCompanyManager(params){// 批量设置管理员
    const url =  baseURL + '/tbUser/setCompanyManager';
    return axios.post(url, qs.stringify(params));
  },
  hardwareBinding(params){// 企业系统设置
    const url =  baseURL + '/tbCompany/hardwareBinding';
    return axios.post(url, qs.stringify(params));
  },
  userExcelTemplate(params){// 下载用户导入模板
    const url =  baseURL + '/tbAuthorizedproduct/userExcelTemplate';
    return url;
  },
  getCompany(params){// 获取企业信息
    const url =  baseURL + '/tbCompany/getCompany';
    return axios.post(url, qs.stringify(params));
  }
}


// WEBPACK FOOTER //
// ./src/api/admin.js